/**
 *  @class
 *  @function AccountDrawer
 */
if (!customElements.get('account-drawer')) {
    class AccountDrawer extends HTMLElement {
      constructor() {
        super();
  
        this.accountDrawerSection = document.querySelector('.account-drawer-section');
      }
  
      connectedCallback() {
        setTimeout(() => {
          this.setupEventListener();

          if (!window.recentlyViewedIds.length) {
            const emptyDiv = document.querySelector('.recent-empty');
            const resultsDiv = document.querySelector('.recent-valid');
            if (emptyDiv && resultsDiv) {
              emptyDiv.style.display = 'block';
              resultsDiv.style.display = 'none';
            }
          }
        }, 200);
      }
  
      setupEventListener() {
        //this.fetchKlaviyoProfileId();

        const tabs = this.querySelectorAll('.account-drawer__tabs .tab');
        tabs.forEach((tab) => {
            tab.addEventListener('click', this.onTabSelect)
        })
  
        const accountLinks = document.querySelectorAll('.thb-secondary-area-item.my-account, .thb-mobile-account-link');
        if (accountLinks.length) {
          for (let i = 0; i < accountLinks.length; i += 1) {
            accountLinks[i]?.addEventListener('click', () => {
              this.openAccountDrawer(event, this)
          });
          }
        }
        
  
        const wishlistIcon = document.querySelector('.thb-secondary-area-item.thb-wishlist');
        wishlistIcon?.addEventListener('click', () => {
          // Add the callback to render the wishlist
          window.SwymCallbacks.push(swymRenderWishlist);
          setTimeout(() => {
            this.openWishlistDrawer(event, this)
          }, 100)
        });
  
        const closeIcon = this.querySelector('.close');
        closeIcon?.addEventListener('click', () => {
            this.closeAccountDrawer(event, this)
        });
  
        const buyAgainButtons = document.querySelectorAll('buy-again-button');
        buyAgainButtons?.forEach((button) => {
          button.addEventListener('click', () => {
            this.buyAgain(event, this)
          })
        })
  
        const addNewAddressButton = this.querySelector('.account-drawer__add-new-address-button');
        addNewAddressButton?.addEventListener('click', () => {
          this.open2ndAccountDrawer(event, this, "account-drawer-addresses")
        })
  
        const perferenceButton = this.querySelector('.account-drawer__preferences');
        perferenceButton?.addEventListener('click', () => {
          this.open2ndAccountDrawer(event, this, "account-drawer-personal")
        })
  
        const wishlistButton = this.querySelector('.account-drawer-wishlist-btn');
        wishlistButton?.addEventListener("click", () => {
          this.open2ndAccountDrawer(event, this, "account-drawer-wishlists");
        })

        const orderItem = this.querySelectorAll('.account-drawer__order-item');
        orderItem?.forEach((item) => {
          item.addEventListener("click", () => {
            this.open2ndAccountDrawer(event, this, "account-drawer-orders");
            const orderName = item.getAttribute('data-order-name');

            const orders = document.querySelectorAll('.account-drawer-orders .account-drawer-order');
            orders?.forEach((orderItem) => {
              const itemName = orderItem.getAttribute('data-order-name');

              if(itemName == orderName) {
                orderItem.classList.add('active')
              }
              else {
                orderItem.classList.remove('active')
              }
            })
          })
        })

        const recentViewedButton = this.querySelector(".account-drawer__recently-viewed-title");
        recentViewedButton?.addEventListener("click", () => {
          if (window.recentlyViewedIds.length) {
            this.open2ndAccountDrawer(event, this, "account-drawer-rencently-viewed")
          } else {

          }
        })

        const addressRow = document.querySelector('.address-row');
        if (addressRow) {
          const prev = addressRow.querySelector('.address__prev');
          const next = addressRow.querySelector('.address__next');

          if (prev && next) {
            prev.addEventListener('click', () => {
              addressRow.scrollBy({
                top: 0,
                left: - (addressRow.scrollLeft % 300 + 300),
                behavior: 'smooth'
              })
            })
            next.addEventListener('click', () => {
              addressRow.scrollBy({
                top: 0,
                left: (addressRow.scrollLeft % 300 + 300),
                behavior: 'smooth'
              })
            })
          }
        }
      }

    //   fetchKlaviyoProfileId() {
     
    //     const options = {
    //       method: 'GET',
    //       headers: {
    //         accept: 'application/json',
    //         revision: '2024-10-15',
    //         Authorization: 'Klaviyo-API-Key pk_c1ed9bbae36652cc014d84eaef8efc4fba',
    //         "Access-Control-Allow-Origin": "*"
    //       }
    //     };

      
    //     fetch('https://a.klaviyo.com/api/profiles/01JEZ6V1P6N7WJK673S4RBFK4W', options)
   
    //       .then(res => console.log("ressssss", res))
    //       .catch(err => {
           
    //       });
    //  }

      buyAgain(event, ref) {
        const currentTarget = event.currentTarget;
        const items = [];
  
        currentTarget.parentNode.previousElementSibling?.querySelectorAll('.account-drawer__order-item-images img').forEach((img) => {
          const variantId = img.getAttribute('data-variant');
          const quantity = img.getAttribute('data-qty');
  
          items.push({
            id: variantId,
            quantity: quantity
          })
        })
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
      })
      .then(response => response.json())
      .then((res) => {
        window.location.reload();
      })
      }
  
      openAccountDrawer(event, ref) {
        ref.accountDrawerSection.classList.add('active');

        const tabs = document.querySelectorAll(('.account-drawer__tabs>span.tab'));
        for (let i = 0; i < tabs.length; i ++) {
          tabs[i].classList.remove('active');
        }
        const forTab = document.querySelector(('.account-drawer__tabs>span.tab[for="for-you"]'));
        if (forTab) {
          forTab.classList.add('active');
        }
        setTimeout(() => {
          document.querySelector("account-drawer-overlay").classList.add('active');
          document.body.style.overflow = 'hidden';
        }, 200)
  
        const accountDrawer1st = ref.accountDrawerSection.querySelector("account-drawer");
        const accountDrawers2nd = ref.accountDrawerSection.querySelectorAll("account-drawer-2nd");
        const accountDrawers3rd = ref.accountDrawerSection.querySelectorAll("account-drawer-3rd");
  
        accountDrawer1st.classList.add('active');
        accountDrawers2nd.forEach((drawer) => {
          drawer.classList.remove('active')
        })
        accountDrawers3rd.forEach((drawer) => {
          drawer.classList.remove('active')
        })
      }
  
      closeAccountDrawer(event, ref) {
        ref.accountDrawerSection.classList.remove('active');
        document.body.style.overflow = '';
        document.querySelector("account-drawer-overlay").classList.remove('active');
      }
  
      onTabSelect(event) {
        const tabs = Array.from(event.currentTarget.parentNode.children).filter(child => child !== event.currentTarget);  
        tabs.forEach((tab) => {
            tab.classList.remove('active');
        }) 
  
        event.currentTarget.classList.add('active');
  
        const cards = event.currentTarget.parentNode.parentNode.querySelectorAll('.account-drawer__card');
        cards.forEach((card) => {
            card.classList.remove('active');
        })
  
        const currentCardClassName = event.currentTarget.getAttribute('for');
        event.currentTarget.parentNode.parentNode.querySelector(`.account-drawer__card.${currentCardClassName}`).classList.add('active');
      }
  
      openWishlistDrawer(event, ref) {
        ref.accountDrawerSection.classList.add('active');
        setTimeout(() => {
          document.querySelector("account-drawer-overlay").classList.add('active');
          document.body.style.overflow = 'hidden';
        }, 200)
  
        const firstDrawer = ref.accountDrawerSection.querySelector("account-drawer");
        const secondDrawer = ref.accountDrawerSection.querySelector(`account-drawer-2nd.account-drawer-wishlists`);
  
        firstDrawer.classList.remove('active');
        secondDrawer.classList.add('active');
      }
  
      open2ndAccountDrawer(event, ref, className) {
        const secondDrawer = ref.accountDrawerSection.querySelector(`account-drawer-2nd.${className}`);
  
        ref.classList.remove('active');
        secondDrawer.classList.add('active');

        setTimeout(() => {
          const emailForm = document.querySelector('.klaviyo-email-form[data-email]');
          if (emailForm) {
            const email = emailForm.dataset.email;
            const subscribed = emailForm.dataset.subscribed === 'true';
            const emailInput = emailForm.querySelector('input[type="email"]');
            const button = emailForm.querySelector('button');
            if (emailInput) {
              emailInput.click();
              emailInput.focus();
              emailInput.palceholder = email;
              emailInput.value = email;
              emailForm.click();

              emailInput.addEventListener('change', () => {
                emailInput.value = email;
                emailInput.click();
              })
            }
            if (subscribed && button) {
              button.style.display = 'none';
            }
          }
          const phoneForm = document.querySelector('.klaviyo-sms-form[data-phone]');
          if (phoneForm) {
            const phone = phoneForm.dataset.phone;
            const subscribed = phoneForm.dataset.subscribed === 'true';
            const phoneInput = phoneForm.querySelector('input[type="tel"]');
            const buttons = phoneForm.querySelectorAll('button');
            if (phoneInput) {
              phoneInput.click();
              phoneInput.palceholder = phone;
              phoneInput.value = phone;
              phoneForm.click();
            }
            if (buttons.length && subscribed) {
              for(let i = 0; i < buttons.length; i += 1) {
                buttons[i].style.display = 'none';
              }
            }
          }
        }, 500);
      }
    }
    customElements.define('account-drawer', AccountDrawer);
}
  
if (!customElements.get('account-drawer-2nd')) {
  class AccountDrawer2nd extends HTMLElement {
    constructor() {
      super();

      this.accountDrawerSection = document.querySelector('.account-drawer-section');
    }

    connectedCallback() {
      setTimeout(() => {
        this.setupEventListener();
      }, 100);
    }

    setupEventListener() {
      const returnButtons = this.querySelectorAll('.account-drawer__heading .return');
      returnButtons?.forEach((returnButton) => {
        returnButton?.addEventListener('click', () => {
          this.close2ndAccountDrawer(event, this)
        })
      })
     

      const closeButtons = this.querySelectorAll('.account-drawer__heading .close');
      closeButtons?.forEach((closeButton) => {
        closeButton?.addEventListener('click', () => {
          this.closeAccountDrawerSection(event, this)
        })
      })

      const addNewAddressButton = this.querySelector('.account-drawer__add-address');
      addNewAddressButton?.addEventListener('click', () => {
        this.open3rdAccountDrawer(event, this)
      })

      const addressCards = document.querySelectorAll('.account-drawer__address');
      const ref = this;
      addressCards.forEach((addressCard) => {
        addressCard?.addEventListener('click', () => {
          ref.open3rdAccountDrawer(event, ref)
        })
      })
    }

    close2ndAccountDrawer(event, ref) {
      const accountDrawer1st = ref.accountDrawerSection.querySelector('account-drawer');
      ref.classList.remove('active');
      accountDrawer1st.classList.add('active');
    }

    closeAccountDrawerSection(event, ref) {
      ref.accountDrawerSection.classList.remove('active');
      document.body.style.overflow = '';
      document.querySelector("account-drawer-overlay").classList.remove('active');
    }

    open3rdAccountDrawer(event, ref) {
      const addressId = event.currentTarget.getAttribute('data-address-id');
      const accountDrawer3rd = ref.accountDrawerSection.querySelector('account-drawer-3rd');
      const activeAddressCards = accountDrawer3rd.querySelectorAll(`.account-drawer__card`);
      const accountDrawer3rdTitle = accountDrawer3rd.querySelector('.account-drawer__heading .title');

      accountDrawer3rd.classList.add('active');
      ref.classList.remove('active');
      
      activeAddressCards.forEach((card) => {
        const id = card.getAttribute('data-address-id');
        if (id == addressId) {
          card.classList.add('active')
        }
        else {
          card.classList.remove('active')
        }
      })

      if (addressId == "new") {
        accountDrawer3rdTitle.innerHTML = 'add address'
      }
      else {
          accountDrawer3rdTitle.innerHTML = 'edit address'
      }
    }
  }

  customElements.define('account-drawer-2nd', AccountDrawer2nd);
}

if (!customElements.get('account-drawer-3rd')) {
  class AccountDrawer3rd extends HTMLElement {
    constructor() {
      super();

      this.accountDrawerSection = document.querySelector('.account-drawer-section');
    }

    connectedCallback() {
      setTimeout(() => {
        this.setupEventListener();
      }, 100);
    }
    
    setupEventListener() {
      const returnButton = this.querySelector('.account-drawer__heading .return');
      returnButton.addEventListener('click', () => {
        this.close3rdAccountDrawer(event, this)
      })

      const closeButton = this.querySelector('.account-drawer__heading .close');
      closeButton.addEventListener('click', () => {
        this.closeAccountDrawerSection(event, this)
      })

      const delteAddressButtons = this.querySelectorAll('.account-delete-address-button');
      delteAddressButtons?.forEach((button) => {
        button.addEventListener("click", () => {
          this.deleteAddress(event, this)
        })
      })
    }

    deleteAddress(event, ref) {
      const addressId = event.currentTarget.getAttribute('data-address-id');
      setTimeout(() => {
        event.currentTarget?.parentNode.parentNode.classList.add("hide")
      }, 800)

      fetch(`/account/addresses/${addressId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: '_method=delete'
      })
        .then(response => {
          ref.close3rdAccountDrawer(event, ref)
          const addressesToHide = document.querySelectorAll(`[data-address-id="${addressId}"]`);
          const addressList = document.querySelector('.address-row__list');
          if (addressesToHide.length) {
            for (let i = 0; i < addressesToHide.length; i += 1) {
              addressesToHide[i].style.display = 'none'
            }
          }
          if (addressList) {
            addressList.style.width = `${Number.parseInt(addressList.clientWidth) - 300}px`;
          }
        })

    }

    close3rdAccountDrawer(event, ref) {
      ref.classList.remove('active');

      const accountDrawer2nd = ref.accountDrawerSection.querySelector('account-drawer-2nd');
      accountDrawer2nd.classList.add('active');
    }

    closeAccountDrawerSection(event, ref) {
      ref.accountDrawerSection.classList.remove('active');
      document.body.style.overflow = '';
      document.querySelector("account-drawer-overlay").classList.remove('active');
    }
  }

  customElements.define('account-drawer-3rd', AccountDrawer3rd);
}

if (!customElements.get('account-drawer-overlay')) {


  class AccountDrawerOverlay extends HTMLElement {
    constructor() {
      super();

      this.accountDrawerSection = document.querySelector('.account-drawer-section');
    }

    connectedCallback() {
      this.addEventListener('click', this.closeAccountDrawer);
    }

    closeAccountDrawer(event) {
      this.accountDrawerSection.classList.remove('active');
      document.body.style.overflow = '';
      this.classList.remove('active');
    }
  }

  customElements.define('account-drawer-overlay', AccountDrawerOverlay)
}


  
  
    